import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Box, CircularProgress, Typography } from '@mui/material';

function ProtectedRoute({ children }) {
  const { currentUser, loading } = useAuth();

  if (loading) {
    return (
      <Box 
        display="flex" 
        flexDirection="column" 
        alignItems="center" 
        justifyContent="center" 
        minHeight="100vh"
        gap={2}
      >
        <CircularProgress size={60} />
        <Typography variant="h6" color="primary">
          Loading Earn-E...
        </Typography>
      </Box>
    );
  }

  if (!currentUser) {
    return <Navigate to="/auth" replace />;
  }

  // Only render children - don't redirect
  // The children are the actual dashboard pages
  return children;
}

export default ProtectedRoute;
